import styled, { css } from 'styled-components';

import { IPickerAspectUiPattern } from '@rbi-ctg/menu';
import { isUiPatternRadio } from 'state/menu/types';

export const CaloriesWrapper = styled.div<IPickerAspectUiPattern>`
  ${p =>
    isUiPatternRadio(p) &&
    css`
      display: none;
    `}
  line-height: 1;
`;
